import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';

export {
    convertToSchedulingSelectionItem,
    isSchedulingSelectionItem,
    isAttendeeItem,
    useScrollToSelectionItemHooks,
} from 'owa-day-grid-core-utilities';

export {
    resetDayGrid,
    navigateToDate,
    updateNumDaysInDayRange,
    updateFolderIds,
    updateSelectionItem,
    updateDateRangeType,
    getScenarioStore,
} from 'owa-day-grid-core-schema';
export type { DayGridViewState } from 'owa-day-grid-core-schema';

const lazyModule = new LazyModule(
    () => import(/*webpackChunkName: "SchedulingGrid" */ './lazyIndex')
);

export const initializeSchedulingGrid = new LazyAction(lazyModule, m => m.initializeDayGrid);
export const ComposeSchedulingGrid = createLazyComponent(lazyModule, m => m.ComposeSchedulingGrid);
